import { gql } from '@apollo/client';

export const DELETE_SALES_REGION_MUTATION = gql`
  mutation DeleteSalesRegion($id: Int!) {
    mcp {
      deleteSalesRegion(id: $id) {
        success
        message {
          code
          message
        }
        content
      }
    }
  }
`;
